import { render, staticRenderFns } from "./RelatorioDetalhe.vue?vue&type=template&id=38a42cf4&lang=pug"
import script from "./RelatorioDetalhe.vue?vue&type=script&lang=js"
export * from "./RelatorioDetalhe.vue?vue&type=script&lang=js"
import style0 from "./RelatorioDetalhe.vue?vue&type=style&index=0&id=38a42cf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports